var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrayer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#353F49",
    d: "M183.4,439.3L183.4,439.3c-4.9-1.7-7.5-7.1-5.8-12l7.7-22.1c1.7-4.9,7.1-7.5,12-5.8l0,0 c4.9,1.7,7.5,7.1,5.8,12l-7.7,22.1C193.7,438.5,188.3,441,183.4,439.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#353F49",
    d: "M328.2,439.3L328.2,439.3c4.9-1.7,7.5-7.1,5.8-12l-7.7-22.1c-1.7-4.9-7.1-7.5-12-5.8l0,0 c-4.9,1.7-7.5,7.1-5.8,12l7.7,22.1C317.9,438.5,323.3,441,328.2,439.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#353F49",
    d: "M364.1,148.4h-8.8c0-54.9-44.6-99.5-99.5-99.5c-54.9,0-99.5,44.6-99.5,99.5h-8.8 c0-59.7,48.6-108.3,108.3-108.3C315.5,40.1,364.1,88.7,364.1,148.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 125.2,
    transform: "matrix(0.8028 -0.5963 0.5963 0.8028 -62.0875 124.1967)",
    fill: "#353F49",
    width: 23.5,
    height: 61.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 338.8,
    y: 132.5,
    transform: "matrix(-0.8028 -0.5962 0.5962 -0.8028 534.6456 503.3149)",
    fill: "#353F49",
    width: 23.5,
    height: 61.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 277,
    y: 102.6,
    transform: "matrix(-0.803 -0.596 0.596 -0.803 428.433 408.3524)",
    fill: "#353F49",
    width: 9.3,
    height: 61.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F77B55",
    d: "M409.9,281c0,85.1-69,154.1-154.1,154.1c-85.1,0-154.1-69-154.1-154.1c0-85.1,69-154.1,154.1-154.1 C340.9,126.9,409.9,195.9,409.9,281z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF916E",
    d: "M403.4,281c0,81.5-66.1,147.6-147.6,147.6c-81.5,0-147.6-66.1-147.6-147.6 c0-81.5,66.1-147.6,147.6-147.6C337.3,133.4,403.4,199.4,403.4,281z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F77B55",
    d: "M388.8,281c0,73.4-59.5,133-133,133c-73.4,0-133-59.5-133-133c0-73.4,59.5-133,133-133 C329.2,148,388.8,207.5,388.8,281z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M373.5,281c0,65-52.7,117.7-117.7,117.7c-65,0-117.7-52.7-117.7-117.7c0-65,52.7-117.7,117.7-117.7 C320.8,163.3,373.5,216,373.5,281z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#353F49",
    points: "255.8,290.7 197.1,256.8 202.5,247.4 255.8,278.1 333,231.9 338.4,241.4  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F77B55",
    d: "M270.7,281c0,8.2-6.7,14.9-14.9,14.9c-8.2,0-14.9-6.7-14.9-14.9c0-8.2,6.7-14.9,14.9-14.9 C264,266.1,270.7,272.7,270.7,281z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#353F49",
    d: "M260.6,177.1c0,2.6-2.1,4.8-4.8,4.8c-2.6,0-4.8-2.1-4.8-4.8c0-2.6,2.1-4.8,4.8-4.8 C258.4,172.3,260.6,174.4,260.6,177.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#353F49",
    d: "M208,188.6c1.3,2.3,0.5,5.2-1.7,6.5c-2.3,1.3-5.2,0.5-6.5-1.7c-1.3-2.3-0.5-5.2,1.7-6.5 C203.8,185.6,206.7,186.3,208,188.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#353F49",
    d: "M168.2,224.9c2.3,1.3,3.1,4.2,1.8,6.5c-1.3,2.3-4.2,3.1-6.5,1.7c-2.3-1.3-3.1-4.2-1.7-6.5 C163,224.4,165.9,223.6,168.2,224.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#353F49",
    d: "M151.9,276.2c2.6,0,4.8,2.1,4.8,4.8c0,2.6-2.1,4.8-4.8,4.8c-2.6,0-4.8-2.1-4.8-4.8 C147.2,278.3,149.3,276.2,151.9,276.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#353F49",
    d: "M163.5,328.8c2.3-1.3,5.2-0.5,6.5,1.8s0.5,5.2-1.8,6.5c-2.3,1.3-5.2,0.5-6.5-1.8 C160.4,333,161.2,330.1,163.5,328.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#353F49",
    d: "M199.7,368.6c1.3-2.3,4.2-3.1,6.5-1.8c2.3,1.3,3.1,4.2,1.7,6.5c-1.3,2.3-4.2,3.1-6.5,1.8 C199.2,373.8,198.4,370.8,199.7,368.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#353F49",
    d: "M251,384.9c0-2.6,2.1-4.8,4.8-4.8c2.6,0,4.8,2.1,4.8,4.8c0,2.6-2.1,4.8-4.8,4.8 C253.2,389.6,251,387.5,251,384.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#353F49",
    d: "M303.6,373.3c-1.3-2.3-0.5-5.2,1.8-6.5c2.3-1.3,5.2-0.5,6.5,1.8c1.3,2.3,0.5,5.2-1.8,6.5 C307.8,376.4,304.9,375.6,303.6,373.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#353F49",
    d: "M343.4,337c-2.3-1.3-3.1-4.2-1.7-6.5c1.3-2.3,4.2-3.1,6.5-1.8c2.3,1.3,3.1,4.2,1.7,6.5 C348.6,337.6,345.7,338.3,343.4,337z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#353F49",
    d: "M359.7,285.7c-2.6,0-4.8-2.1-4.8-4.8c0-2.6,2.1-4.8,4.8-4.8c2.6,0,4.8,2.1,4.8,4.8 C364.5,283.6,362.3,285.7,359.7,285.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#353F49",
    d: "M348.2,233.2c-2.3,1.3-5.2,0.5-6.5-1.7c-1.3-2.3-0.5-5.2,1.7-6.5c2.3-1.3,5.2-0.5,6.5,1.7 C351.2,228.9,350.4,231.8,348.2,233.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#353F49",
    d: "M311.9,193.4c-1.3,2.3-4.2,3.1-6.5,1.7c-2.3-1.3-3.1-4.2-1.8-6.5c1.3-2.3,4.2-3.1,6.5-1.7 C312.4,188.2,313.2,191.1,311.9,193.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F77B55",
    d: "M200,117.5c-19.4-24.7-55-29.7-80.4-10.8c-25.4,18.8-30.9,54.4-12.9,80.1L200,117.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 113.9,
    y: 144.2,
    transform: "matrix(0.8029 -0.5962 0.5962 0.8029 -61.5859 109.3606)",
    fill: "#FFFFFF",
    width: 41.3,
    height: 7.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F77B55",
    d: "M312.6,117.5c19.4-24.7,55-29.7,80.4-10.8c25.4,18.8,30.9,54.4,12.9,80.1L312.6,117.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 330.4,
    y: 124.2,
    transform: "matrix(-0.8029 -0.5962 0.5962 -0.8029 556.6753 439.5792)",
    fill: "#FFFFFF",
    width: 41.3,
    height: 7.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#353F49",
    d: "M312.6,107.5c0,6.8-5.6,12.4-12.4,12.4c-6.8,0-12.4-5.5-12.4-12.4c0-6.8,5.5-12.4,12.4-12.4 C307,95.2,312.6,100.7,312.6,107.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FECA5C",
    d: "M103.8,382.1l4.9-3.7c-20.3-27.2-32.4-60.9-32.4-97.4c0-23.4,5-45.7,13.9-65.8l-5.6-2.5 c-9.2,20.9-14.4,44-14.4,68.3C70.2,318.8,82.7,353.8,103.8,382.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FECA5C",
    d: "M78.1,397.4l4.9-3.7C59.3,362.2,45.2,323,45.2,280.6c0-27,5.7-52.6,16-75.9l-5.6-2.5 c-10.6,24-16.5,50.5-16.5,78.3C39.1,324.4,53.6,364.8,78.1,397.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FECA5C",
    d: "M53.1,417.8l4.9-3.7c-28-37.2-44.7-83.5-44.7-133.6c0-31.9,6.8-62.2,18.9-89.6l-5.6-2.5 c-12.4,28.2-19.4,59.3-19.4,92.1C7.3,332.1,24.4,379.6,53.1,417.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FECA5C",
    d: "M407.8,382.1l-4.9-3.7c20.3-27.2,32.4-60.9,32.4-97.4c0-23.4-5-45.7-13.9-65.8l5.6-2.5 c9.3,20.9,14.4,44,14.4,68.3C441.4,318.8,428.9,353.8,407.8,382.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FECA5C",
    d: "M433.5,397.4l-4.9-3.7c23.7-31.5,37.8-70.7,37.8-113.1c0-27-5.7-52.6-16-75.9l5.6-2.5 c10.6,24,16.5,50.5,16.5,78.3C472.6,324.4,458,364.8,433.5,397.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FECA5C",
    d: "M458.5,417.8l-4.9-3.7c28-37.2,44.7-83.5,44.7-133.6c0-31.9-6.8-62.2-18.9-89.6l5.6-2.5 c12.4,28.2,19.4,59.3,19.4,92.1C504.4,332.1,487.3,379.6,458.5,417.8z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrayer);
export default __webpack_public_path__ + "static/media/prayer.bac350b5c67ccca03b35cb1c9bd2314e.svg";
export { ForwardRef as ReactComponent };